module.exports = __webpack_public_path__ + "img/V18.d6d8f18d.jpg";